import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button } from 'tea-component';

import MessageEmpty from '@/pages/datalab/assets/img/message-empty1.png';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CreateChart from '../CreateChart';
import Loading from '@/pages/dashboard/components/Loadings';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import { useDispatch, history } from 'umi';
import { ADD_ANALYSIS } from '../../../Home/GettingStart';
import ContactShow from "@/pages/datalab/components/DashboardLayout/components/ContactShow";

const AddChartNoData = (props: any) => {
  const { handleOnSubmit, layoutLoading, hasChartPrivilege, gameCode, showContact, contactInfo } = props;
  const [open, setOpen] = useState(false);
  const { dblFormatMessage, formatMessage } = useDblIntl('create_dashboard');
  const dispatch = useDispatch();
  // const [guidanceValue = []] = useStore<Array<string>>('useGuidanceNum', []);
  useEffect(() => {
    dispatch({
      type: 'customDashboard/save',
      payload: {
        isHideCustomLeaveModal: true,
      },
    });
    return () => {
      dispatch({
        type: 'customDashboard/save',
        payload: {
          isHideCustomLeaveModal: false,
        },
      });
    };
  }, []);
  const handleOnClickOpenAddChartsModal = () => {
    try {
      if (window.location.href.includes('helpType')) {
        const linkUrl = `/Analysis/MultiAnalysis?helpType=${ADD_ANALYSIS}`;
        history.push(`/datalab/${gameCode}${linkUrl}`);
        return;
      }
      setOpen(true);
    } catch (error) {
      setOpen(true);
    }
  };
  return (
    <div className="dbl-dashboard-contact-wrap">
      <div className="dbl-chart-nodata-box">
        <div className="dbl-chart-nodata">
          {layoutLoading ? (
            <Loading/>
          ) : (
            <>
              <img src={MessageEmpty} className="dbl-chart-nodata-img"/>
              <div className="dbl-chart-nodata-title">
                {dblFormatMessage('blank_title')}
              </div>
              <div className="dbl-chart-nodata-text">
                {dblFormatMessage('blank_des')}
              </div>
              {hasChartPrivilege ? (
                <Button
                  type="primary"
                  className="dbl-chart-nodata-btn"
                  onClick={handleOnClickOpenAddChartsModal}
                >
                  <SvgIcon
                    type="add-icon-type"
                    className="dbl-chart-nodata-btnicon"
                  />
                  {formatMessage({id: 'dbl_myAnalysis_new'})}
                </Button>
              ) : (
                ''
              )}
            </>
          )}
        </div>
        <CreateChart
          handleOnSubmit={handleOnSubmit}
          visible={open}
          close={() => setOpen(!open)}
        />
      </div>
      {
        showContact ? (<ContactShow email={contactInfo.email} userName={contactInfo.username}/>) : ''
      }
    </div>
  );
};

export default AddChartNoData;
